export default __webpack_public_path__ + "static/codewithme-screenshot-ba059871a231df2430471a8c192ce138.png";